import { VChip } from 'vuetify/lib/components/VChip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isVisibleFilters
    ? _c(
        "div",
        _vm._l(_vm.chips, function (chip) {
          return _c(
            VChip,
            {
              key: chip.value,
              staticClass: "mr-2",
              attrs: {
                value: chip.value,
                color: chip.isActive ? "primary" : "bg-primary",
                "text-color": chip.isActive ? "bg-gray-0" : "primary",
              },
              on: {
                click: function ($event) {
                  return _setup.handleClickFilter(chip)
                },
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(chip.text) +
                  " (" +
                  _vm._s(chip.amount) +
                  ")\n  "
              ),
            ]
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }